import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
    selector: 'search.modal.page',
    templateUrl: './search.modal.page.html',
    styleUrls: [],
})
export class SearchModalPage implements OnInit {

    searchText: string;
    searchResults = [];
    constructor(
        private modalController: ModalController,
        private navParams: NavParams,
    ) { }

    ngOnInit() {
        this.searchResults = this.navParams.data.searchResults;
    }

    closeModal() {

        this.modalController.dismiss(null);
    }
    selectAddress(item) {
        this.modalController.dismiss(item);
    }

    back() {
        this.modalController.dismiss(null);
    }
}
